import * as React from 'react';
import { Translate } from '../../../../../../../shared/LanguageService';

type ExternalProps = {
    receiverTranslationKey: string;
};

type InvoiceCommercialLabels = {
    receiver: string;
};

type InvoiceCommercialProps = {
    labels: InvoiceCommercialLabels;
    receiver: string;
};

export function InvoiceCommercial({ labels, receiver }: InvoiceCommercialProps) {
    return (
        <dl>
            <dt>{labels.receiver}</dt>
            <dd>{receiver}</dd>
        </dl>
    );
}

export default function TranslatedInvoiceCommercial({ receiverTranslationKey }: ExternalProps) {
    let labels = {
        receiver: Translate('view-order/basic-order-info/invoice-info/receiver')
    };

    return <InvoiceCommercial labels={labels} receiver={Translate(receiverTranslationKey)} />;
}
